import { NamedItem } from 'domain/common/namedItem'
import { adminHttpClient } from '../commons/adminHttpClient'

export type UpdateCompanyUserPersonalDetailsRequest = {
  id: string
  firstName: string
  lastName: string
  workPhone?: string
  workEmail: string
  personalEmail?: string
  identificationNumber?: string
  availableStates: NamedItem[]
  receiveSms: boolean
  birthDay?: string
  zipCode?: string
}

export const updateEmployeePersonalDetails = (request: UpdateCompanyUserPersonalDetailsRequest): Promise<any> => {
  return adminHttpClient.put(`/Companies/UpdateEmployeePersonalDetails`, request)
}

export default updateEmployeePersonalDetails
